import React from 'react';
import {css} from "@emotion/react";

interface HeatmapCaptionProps {
  heatmapStops: Array<[number, string]>;
  captionTitle: string;
  minValue: number;
  maxValue: number;
  minUnit: string;
  maxUnit: string;
}

const CaptionContainer = css`
  margin-right: 24px;
  margin-top: 8px;
  display: flex;
`;

const TextSquare = css`
  width: inherit;
  height: 17px;
  vertical-align: top;
  background-color: #FFFFFF;
  font-size: 12px;
  margin-right: 4px;
  margin-left: 4px;
`;

const StepSquare = (color: string) => css`
  width: 8px;
  height: 17px;
  background-color: ${color};
  display: inline-block;
  vertical-align: top;
`;

const EdgeSquare = (color: string) => css`
  width: 17px;
  height: 17px;
  background-color: ${color};
  display: flex;
  vertical-align: top;
  justify-content: center;
  font-size: 12px;
  -webkit-text-stroke: 2px #FFFFFF;
  paint-order: stroke fill;
  color: #000000;
`;

export const HeatmapCaption: React.FC<HeatmapCaptionProps> = (
    {heatmapStops, captionTitle, maxValue, minValue, maxUnit, minUnit}) => {
  const stopsSize = heatmapStops.length - 1;
  return (
      <div css={CaptionContainer}>
        <div css={TextSquare}>{captionTitle}:</div>
        <div css={TextSquare}>{minUnit}</div>
        {heatmapStops.map(([_, color], index) => {
          return (
              <span key={index}>
                {index === 0 || index === stopsSize
                    ? <span css={EdgeSquare(color)}>{
                      index === 0 ? minValue : maxValue}</span>
                    : <span css={StepSquare(color)}></span>}
              </span>
          )
        })}
        <div css={TextSquare}>{maxUnit}</div>
      </div>
  )
}

export default HeatmapCaption;
